// Penjaga tombol Simpan Desa: kode desa yang sudah terdaftar memblokir
// penyimpanan. Pengecualian record yang sedang diedit dilakukan backend lewat
// population_id, bukan di sini.
export const isDuplicateVillageCode = ({
  duplicateVillageId,
  currentValue,
}) => duplicateVillageId !== "" && duplicateVillageId === currentValue;
